// Shared geometry for the static onboarding page, OAuth merge animation, and login.
export const ONBOARDING_SHELL_CLASS =
  "flex h-screen w-full bg-[#f4f4f4] p-2 text-[#18181b]";
export const ONBOARDING_ROW_CLASS = "flex min-h-0 w-full flex-1 gap-1";
export const ONBOARDING_CARD_CLASS =
  "relative flex min-h-0 min-w-0 flex-1 overflow-hidden rounded-[12px] bg-[#fcfcfd] shadow-1";
